module.exports = __webpack_public_path__ + "img/mechanics.c9cad3e0.jpg";